import Constants from "expo-constants";

export type EnvConfig = {
  debug: boolean;
  apiUrl: string;
  appUrl: string;
  bugsnagApiKey: string;
  oneSignalAppId: string;
  oneSignalSafariWebId: string;
  pusherAppKey: string;
  pusherCluster: string;
  version: string;
};

const { extra = {}, version } = Constants.expoConfig ?? {};

function env(name: string): string {
  return extra.env?.[name] ?? "";
}

function getEnvConfig(): EnvConfig {
  const appUrl = env("APP_URL");

  return {
    debug: __DEV__,
    apiUrl: `${appUrl}/api/v2`,
    appUrl,
    bugsnagApiKey: env("BUGSNAG_API_KEY"),
    oneSignalAppId: env("ONESIGNAL_APP_ID"),
    oneSignalSafariWebId: env("ONESIGNAL_SAFARI_WEB_ID"),
    pusherAppKey: env("PUSHER_APP_KEY"),
    pusherCluster: env("PUSHER_CLUSTER"),
    version: version ?? "0.0.0",
  };
}

export const Env = getEnvConfig();
